<template>
    <Head>
        <title>Редактирование пользователя  {{manager.name}}</title>
    </Head>

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <div class="py-8 max-w-7xl mx-auto grid gap-4 grid-cols-3 items-start">

            <div class="col-span-full flex flex-row justify-between bg-white rounded p-4 gap-4">

                <v-button-link :href="route('settings.users.index')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
                    </svg>
                    <span class="ml-2">Назад к списку</span>
                </v-button-link>
                <h3 class="font-semibold text-xl text-gray-800 sm:leading-tight my-auto">
                    Редактирование пользователя "{{manager.name}}"
                </h3>

            </div>

            <form
                class="col-span-2 flex flex-col items-stretch gap-4 p-6 bg-white rounded"
                @submit.prevent="save"
                @change="changed = true"
            >

                <v-input v-model="manager.name" label="Имя" class="mt-1 block w-full" :error="errors.name" />

                <v-select label="Роль" v-model="manager.role" :error="errors.role">
                    <option v-for="i of Object.keys(roles)"
                            v-bind:value="i"
                    >{{ i }}</option>
                </v-select>

                <v-input v-model="manager.tgId" label="tgId" class="mt-1 block w-full" :error="errors.tgId" />

                <v-select label="Ментор" v-model="manager.mentorId" :error="errors.mentorId">
                    <option :value="null">Не задан</option>
                    <option v-for="(n, i) of managers"
                            :value="i"
                    >{{ n }}</option>
                </v-select>

                <div class="grid grid-cols-2 gap-4">
                    <div class="flex flex-col gap-1" v-for="(permissions, namespace) in roleList">
                        <b v-if="lang[namespace] && lang[namespace].title">{{ lang[namespace].title }}</b>
                        <b v-else>{{ namespace }}</b>
                        <v-checkbox
                            v-for="permission in permissions"
                            :checked="checkPermission(namespace, permission)"
                            @update:checked="(val) => setPermission(val, namespace, permission)"
                        >
                            <p v-if="lang[namespace] && lang[namespace][permission] && lang[namespace][permission][0] " class="flex flex-col">
                                <b>{{ lang[namespace][permission][0] }}</b>
                                <span v-if="lang[namespace][permission][1]">{{ lang[namespace][permission][1] }}</span>
                            </p>
                            <span class="font-mono" v-else>{{ permission }}</span>
                        </v-checkbox>
                    </div>
                </div>

                <div class="flex justify-end">
                    <Button color="green" :disabled="!changed">
                        Сохранить
                    </Button>
                </div>
            </form>

            <div class="p-6 bg-white rounded flex flex-col gap-4">
                <v-button-link  v-if="manager.deletedAt == null" color="red" :href="route('settings.users.destroy', manager.id)" method="delete">
                    Заблокировать
                </v-button-link>
                <v-button-link  v-else color="green" :href="route('settings.users.restore', manager.id)" method="patch">
                    Разблокировать
                </v-button-link>
                <Button @click="resetPassword" type="button" class="w-full" color="yellow">
                    Сбросить пароль
                </Button>
                <Button type="button" @click="reset2fa" class="w-full" color="yellow">
                    Сбросить 2FA
                </Button>
                <v-button-link :href="route('settings.manager.actions-log', manager.id)">
                    Журнал действий
                </v-button-link>
            </div>
        </div>
    </AuthenticatedLayout>
</template>


<script>
import moment from 'moment';
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import Button from "@/Components/Button";
import VButtonLink from "@/Components/ButtonLink";
import VInput from "@/Components/Input";
import VToggle from "@/Components/Toggle";
import VSelect from "@/Components/Select";
import VCheckbox from "@/Components/Checkbox";

export default {
    components: {
        Head,
        Link,
        AuthenticatedLayout,
        NavigationSettings,
        Button,
        VButtonLink,
        VInput,
        VToggle,
        VSelect,
        VCheckbox
    },
    props: {
        manager: Object,
        managers: Object,
        roles: Object,
        roleList: Object,
        lang: Object,
        errors: Object,
    },
    data() {
        return {
            changed: false,
        }
    },
    methods: {
        moment,
        save() {
            useForm(this.manager).patch(this.route('settings.users.update',this.manager.id));
        },
        resetPassword() {
            if(confirm(`Сбросить пароль ${this.manager.name}?`)) {
                useForm({}).delete(this.route('settings.reset-password',this.manager.id));
            }
        },
        reset2fa() {
            if(confirm('reset 2fa for '+ this.manager.name)){
                useForm({}).delete(this.route('settings.reset2FA',this.manager.id));
            }
        },
        checkPermission(namespace, permission) {
            const {role, permissions} = this.manager;
            const roles = this.roles[role];
            if(typeof roles === 'boolean'
                && (permissions === null || !permissions.hasOwnProperty(namespace) || !permissions[namespace].hasOwnProperty(permission)))
                return roles;
            if(typeof roles[namespace] === 'boolean'
                && (permissions === null || !permissions.hasOwnProperty(namespace) || !permissions[namespace].hasOwnProperty(permission)))
                return roles[namespace];
            try {
                if(roles.hasOwnProperty(namespace) || permissions !== null && permissions.hasOwnProperty(namespace))
                    return (permissions !== null && permissions.hasOwnProperty(namespace) && permissions[namespace].hasOwnProperty(permission) && typeof permissions[namespace][permission] === 'boolean')
                        ? permissions[namespace][permission] : roles[namespace] ? roles[namespace].includes(permission) : false
            } catch (e) {
                console.log({namespace, permission, e})
            }
            return false;
        },
        setPermission(val, namespace, permission)
        {
            if(this.manager.permissions === null)
                this.manager.permissions = {};

            if(!this.manager.permissions[namespace])
                this.manager.permissions[namespace] = {};
            this.manager.permissions[namespace][permission] = val;
        }
    },
}
</script>
